import styled from 'styled-components';
import { screenSmMin } from '@spotify-internal/encore-foundation';
export default styled.ul.withConfig({
  displayName: "List",
  componentId: "sc-2lhaj3-0"
})(["padding-bottom:0;@media (min-width:", "){align-items:center;display:flex;justify-content:flex-start;margin-bottom:0;margin-top:0;}"], screenSmMin);